export type SocialNetwork =
  | "linkedin.com"
  | "github.com"
  | "twitter.com"
  | "facebook.com"
  | "youtube.com"
  | "behance.net"
  | "dribbble.com"
  | "pinterest.com"
  | "stackoverflow.com"
  | "vimeo.com"
  | "angel.co"
  | "flickr.com"
  | "indeed.com"
  | "quora.com"
  | "reddit.com"
  | "about.me"
  | "crunchbase.com"
  | "instagram.com"
  | "foursquare.com"
  | "gravatar.com"
  | "meetup.com"
  | "klout.com";

const NETWORK_DOMAIN_MAP: Record<string, SocialNetwork> = {
  linkedin: "linkedin.com",
  github: "github.com",
  twitter: "twitter.com",
  facebook: "facebook.com",
  youtube: "youtube.com",
  behance: "behance.net",
  dribbble: "dribbble.com",
  pinterest: "pinterest.com",
  stackoverflow: "stackoverflow.com",
  vimeo: "vimeo.com",
  angellist: "angel.co",
  flickr: "flickr.com",
  indeed: "indeed.com",
  quora: "quora.com",
  reddit: "reddit.com",
  aboutme: "about.me",
  crunchbase: "crunchbase.com",
  "linkedin.com": "linkedin.com",
  "github.com": "github.com",
  "twitter.com": "twitter.com",
  "facebook.com": "facebook.com",
  "youtube.com": "youtube.com",
  "behance.net": "behance.net",
  "dribbble.com": "dribbble.com",
  "pinterest.com": "pinterest.com",
  "stackoverflow.com": "stackoverflow.com",
  "vimeo.com": "vimeo.com",
  "angel.co": "angel.co",
  "flickr.com": "flickr.com",
  "indeed.com": "indeed.com",
  "quora.com": "quora.com",
  "reddit.com": "reddit.com",
  "about.me": "about.me",
  "crunchbase.com": "crunchbase.com",
  instagram: "instagram.com",
  "instagram.com": "instagram.com",
  foursquare: "foursquare.com",
  "foursquare.com": "foursquare.com",
  gravatar: "gravatar.com",
  "gravatar.com": "gravatar.com",
  meetup: "meetup.com",
  "meetup.com": "meetup.com",
  klout: "klout.com",
  "klout.com": "klout.com",
};

export function toSocialNetwork(network: string): SocialNetwork | null {
  return NETWORK_DOMAIN_MAP[network.toLowerCase()] ?? null;
}
